import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { useSearchParamState } from "use-search-param-state";

export function PacakgeNameFilter(props: { paramName: string }) {
  const [value, setValue] = useSearchParamState(props.paramName, "");

  return (
    <TextField
      size="small"
      placeholder="Szukaj po nazwie..."
      sx={{ mb: 4, width: { xs: "100%", md: 240 } }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
